module.exports = __webpack_public_path__ + "img/slim_cleanstation07.f64ac86a.jpg";